export type PaginationState = {
    per_page: number
    isLoading: boolean
}

export enum EPaginationMutations {
    SET_PAGE_SIZE = 'setPaginations',
    SET_IS_LOADING = 'setIsLoading'
}
